import React, { FC, ForwardedRef, forwardRef } from 'react';
import { Link, LinkProps, useTheme } from '@mui/material';
import { Logo, LogoProps } from '@/src/components/logo/Logo';
import { getFocusRingStyle } from '@/src/components/focusring/focusring';

export interface HeaderLogoProps extends LinkProps {
  /**
   * Properties applied to Logo component
   */
  logoProps?: LogoProps;
}

/**
 * Logo with link wrapper
 */
export const HeaderLogo: FC<HeaderLogoProps> = forwardRef(({ sx, children, href, logoProps, ...rest }, ref) => {
  const theme = useTheme();

  if (href || rest.onClick) {
    return (
      <Link
        sx={{
          // same style is applied in Header logo wrapper
          display: 'block',
          position: 'relative',
          py: 1,
          // add proper focus ring
          ...getFocusRingStyle(theme),
          // remove default link box shadow
          '&.Mui-focusVisible': {
            boxShadow: 'none',
          },
          '& .MuiSvgIcon-root': {
            display: 'block',
          },
        }}
        href={href || '#'}
        ref={ref}
        aria-label="Home"
        {...rest}
      >
        {children || <Logo {...logoProps} />}
      </Link>
    );
  }
  return <>{children || <Logo sx={sx} ref={ref as unknown as ForwardedRef<SVGSVGElement>} {...logoProps} />}</>;
});
